import React, { useContext, useEffect, useState } from "react";
import Typed from "react-typed";
import Profile from "../../Profile.png";
import ParticlesContainer from "../ParticlesContainer/ParticlesContainer";
import { IsHomePageContext } from "../Provider/IsHomePage";

function Header() {
  const [height, setHeight] = useState(window.innerHeight);

  const [bgColor, setBgColor] = useState("#1F232E");

  const handleMouseEnter = () => {
    setBgColor("#313743"); // Change to desired background color
  };

  const handleMouseLeave = () => {
    setBgColor("#1F232E"); // Change to default background color
  };

  useEffect(() => {
    const handleResize = () => setHeight(window.innerHeight);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [classNameBtn, setClassNameBtn] = useState("btn-main-offer");

  const handleMouseDown = () => {
    setClassNameBtn("btn-main-offer btn-active");
  };

  const handleMouseUp = () => {
    setClassNameBtn("btn-main-offer");
  };

  const handleClick = (e) => {
    e.preventDefault();
    handleMouseDown();
    setTimeout(() => {
      handleMouseUp();
    }, 400);

    const url =
      "https://drive.google.com/uc?export=download&id=1y2mD-JVKOlPazu6E13yhzZ8g3M-8pdui";
    // Replace with the URL of the file you want to download
    // https://drive.google.com/uc?export=download&id=FILE-ID-HERE
    // https://drive.google.com/file/d/your-file-id/view
    const link = document.createElement("a");
    link.href = url;
    link.target = "_blank";
    link.download = "file.pdf"; // Replace with the desired filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const { isHomePage } = useContext(IsHomePageContext);

  return (
    <div
      className="header-wraper"
      style={{
        height: height,
        backgroundColor: bgColor,
        transition: "background-color 0.5s ease",
        zIndex: "10 !important",
      }}
    >
      <div
        style={{
          position: "relative",
          overflow: "hidden",
          width: "100%",
          height: "100vh",
          opacity: isHomePage ? 1 : 0,
          visibility: isHomePage ? "visible" : "hidden",
          transition: "opacity 0.5s ease-in-out, visibility 0.5s ease-in-out",
          zIndex: "-50",
        }}
      >
        <ParticlesContainer />
      </div>
      <div className="main-info">
        <a href="#">
          <img
            className="profile-image"
            src={Profile}
            alt="Profile"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          />
        </a>
        <h1>Ishan Tharindu</h1>
        <div>
          <Typed
            className="typed-text"
            strings={[
              "Freelance Developer",
              "Web Developer",
              "Undergraduate Student",
            ]}
            typeSpeed={40}
            backSpeed={60}
            loop
          />
        </div>
        <a
          href="#"
          target="_blank"
          style={{ cursor: "pointer" }}
          onMouseDown={handleMouseDown}
          onMouseUp={handleMouseUp}
          onClick={handleClick}
          onTouchStart={handleMouseDown}
          onTouchEnd={handleMouseUp}
          className={classNameBtn}
        >
          <span>Download CV</span>
        </a>

        <div className="container social-media">
          <a
            href="https://www.linkedin.com/in/ishantharindu"
            target="_blank"
            className="btn-social-media"
            style={{ cursor: "pointer" }}
          >
            <i className="fab fa-linkedin"></i>
          </a>
          <a
            href="https://github.com/gitgunawardhana"
            target="_blank"
            className="btn-social-media"
            style={{ cursor: "pointer" }}
          >
            <i className="fab fa-github"></i>
          </a>
          <a
            href="https://web.facebook.com/g.ishantharindu8/"
            target="_blank"
            className="btn-social-media"
            style={{ cursor: "pointer" }}
          >
            <i className="fab fa-facebook-square"></i>
          </a>
        </div>
      </div>
    </div>
  );
}

export default Header;
